<template>
  <span>
    <v-row dense v-for="chart in chartDataComputed" :key="chart.chartRef">
      <v-col cols="12">
        <v-card-charts-dashboard
          :title="chart.title"
          :chart-ref="chart.chartRef"
          :options="chart.options"
          :deep-copy-on-update="chart.deepCopyOnUpdate"
          :is-loading="chart.loading"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
import VCardChartsDashboard from "@/components/base/VCardChartsDashboard.vue";

export default {
  components: {
    VCardChartsDashboard,
  },
  name: "DashboardFaturamentoVisaoMunicipiosCardsKpisPorMunicipio",
  props: {
    dados: {
      type: Array,
      required: true,
    },
    metasKpis: {
      type: Object,
      required: true,
    },
    municipios: {
      type: Array,
      required: true,
    },
    tipoOrdenacao: {
      type: String,
      required: true,
    },
    kpiOrdenacao: {
      type: String,
      required: true,
    },
    exportingOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    chartPslOptions: {},
    chartPrfOptions: {},
    chartPcfOptions: {},
    chartData: [
      {
        title: "PSL - Percentual de Faturas Emitidas Sem Leitura",
        chartRef: "chartPslOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "PRF - Percentual de Refaturamentos",
        chartRef: "chartPrfOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "PCF - Percentual de Acertos de Faturamento",
        chartRef: "chartPcfOptions",
        deepCopyOnUpdate: false,
      },
    ],
  }),
  computed: {
    categories() {
      const sortedValues =
        this.tipoOrdenacao === "asc"
          ? this.dados.sort(
              (a, b) =>
                Number(a[this.kpiOrdenacao] ?? 0) -
                Number(b[this.kpiOrdenacao] ?? 0),
            )
          : this.dados.sort(
              (a, b) =>
                Number(b[this.kpiOrdenacao] ?? 0) -
                Number(a[this.kpiOrdenacao] ?? 0),
            );

      return sortedValues.map((el) => el.nome_municipio);
    },
    chartDataComputed() {
      return this.chartData.map((chart) => {
        return {
          ...chart,
          options: this[chart.chartRef],
          loading: this.loading,
        };
      });
    },
  },
  mounted() {
    this.setChartsOptions();
  },
  methods: {
    setChartsOptions() {
      this.setChartPslOptions();
      this.setChartPrfOptions();
      this.setChartPcfOptions();
    },
    getColumnChartDefaultOptions(categories = this.categories) {
      return {
        chart: {
          type: "column",
          height: 400,
          zooming: {
            type: "x",
          },
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: false },
        xAxis: {
          categories: categories,
          crosshair: true,
          title: {
            text: "Município",
          },
        },
        yAxis: {
          type: "logarithmic",
          title: { text: null },
        },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: [],
        exporting: this.exportingOptions,
      };
    },
    setChartPslOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "PSL",
          animation: false,
          data: this.dados.map((dados) => {
            return {
              x: this.municipios.indexOf(dados.nome_municipio),
              y: Number(dados.psl),
              color:
                Number(dados.psl) >
                Number(this.metasKpis?.[dados.codigo_ibge]?.psl)
                  ? "#FF5252"
                  : this.$vuetify.theme.themes.light.primary,
            };
          }),
        },
      ];

      this.chartPslOptions = options;
    },
    setChartPrfOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "PRF",
          animation: false,
          data: this.dados.map((dados) => {
            return {
              x: this.municipios.indexOf(dados.nome_municipio),
              y: Number(dados.prf),
              color:
                Number(dados.prf) >
                Number(this.metasKpis?.[dados.codigo_ibge]?.prf)
                  ? "#FF5252"
                  : this.$vuetify.theme.themes.light.primary,
            };
          }),
        },
      ];

      this.chartPrfOptions = options;
    },
    setChartPcfOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "PCF",
          animation: false,
          data: this.dados.map((dados) => {
            return {
              x: this.municipios.indexOf(dados.nome_municipio),
              y: Number(dados.pcf),
              color:
                Number(dados.pcf) >
                Number(this.metasKpis?.[dados.codigo_ibge]?.pcf)
                  ? "#FF5252"
                  : this.$vuetify.theme.themes.light.primary,
            };
          }),
        },
      ];

      this.chartPcfOptions = options;
    },
  },
  watch: {
    dados() {
      this.setChartsOptions();
    },
    categories() {
      this.setChartsOptions();
    },
  },
};
</script>

<style></style>
